<template>
  <LineChartJS v-if="loaded" :data="chartData" :options="chartOptions" />
</template>

<script>
import { Line as LineChartJS } from "vue-chartjs";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
  Filler,
  SubTitle,
} from "chart.js";

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
  Filler,
  SubTitle
);

export default {
  components: { LineChartJS },

  data() {
    return {
      loaded: false,
      chartData: {
        labels: [
          "Momento 1",
          "Momento 2",
          "Momento 3",
          "Momento 4",
          "Momento 5",
          "Momento 6",
        ],
        datasets: [
          {
            label: "",
            data: [3, 3, 4, 2, 1, 5],
            fill: true,
            borderColor: "#0cc2b7",
            backgroundColor: "#0cc2b761",
          },
        ],
      },
      chartOptions: {
        responsive: true,
        maintainAspectRatio: false,
        scales: {
          y: {
            min: 0,
            max: 5,
            ticks: {
              color: "#FFFFFF",
            },
            grid: {
              color: "#000000",
            },
          },
          x: {
            ticks: {
              color: "#FFFFFF",
            },
            grid: {
              color: "#000000",
            },
          },
        },
        plugins: {
          title: {
            display: true,
            align: "start",
            text: "Gráfica de Resultado de Valoraciones",
            color: "#FFFFFF",
          },
          legend: {
            display: false,
          },
          subtitle: {
            display: true,
            text: "",
          },
        },
      },
    };
  },

  props: ["labelsProp", "dataProp"],

  watch: {
    dataProp() {
      this.loaded = false;
      this.chartData.labels = this.labelsProp;
      this.chartData.datasets[0].data = this.dataProp;
      this.loaded = true;
    },
  },

  mounted() {
    this.chartData.labels = this.labelsProp;
    this.chartData.datasets[0].data = this.dataProp;
    this.loaded = true;
    // console.log(this.dataProp);
    // console.log(this.labelsProp);
  },
};
</script>

<style></style>
